import Game from "../../rest/jtmc/models/Game";
import React from "react";

export default function GameFrame(props: {game: Game}){
    return <iframe style={{width: "100%", height: "100%"}} src={props.game.url}>
    </iframe>;
}